// Based off a tweet and codesandbox:
// https://mobile.twitter.com/hieuhlc/status/1164369876825169920
import { useRef } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';
export function useAnimationFrame(callback) {
    const savedCallback = useRef(callback);
    // Remember the latest callback if it changes.
    useIsomorphicLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    const frame = useRef();
    const init = useRef(performance.now());
    const last = useRef(performance.now());
    const animate = (now) => {
        // In seconds ~> you can do ms or anything in userland
        savedCallback.current(now - init.current, now - last.current);
        last.current = now;
        frame.current = requestAnimationFrame(animate);
    };
    useIsomorphicLayoutEffect(() => {
        frame.current = requestAnimationFrame(animate);
        return () => {
            if (frame.current != null) {
                cancelAnimationFrame(frame.current);
            }
        };
    }, [animate]);
}
//# sourceMappingURL=useAnimationFrame.js.map